// extracted by mini-css-extract-plugin
export default {"header":"AlertSection_header__D0FKX","alerts":"AlertSection_alerts__oGhIu"};